import { GridItemOption, WidgetBaseOption } from '..';
import { AuditDetails } from '../../entity';


export interface Widget<TOption extends WidgetBaseOption = any> extends AuditDetails {
    _id: string;
    name?: string;
    system?: boolean;

    /** widget._id in library */
    templateId?: string;

    type: WidgetType;
    category: WidgetCategory;

    /** depends on type */
    option?: TOption;

    /** size, position */
    grid?: GridItemOption;
}


export enum WidgetEntity {
    Job = "Job",
    Stage = "Stage",
    Opportunity = "Opportunity",
    Quote = "Quote",
    Invoice = "Invoice",
    Item = "Item",
    Lead = "Lead",

    Unknown = "Unknown",
}

export enum WidgetType {
    Chart = 'chart',
    Card = 'card',
    Grid = 'grid',
}

export enum WidgetActionType {
    GroupBy,
    Sum,
    Count,
    Raw,
    Average,
    Special,
}

export enum WidgetCategory {
    Job = "Job",
    Stage = "Stage",
    Opportunity = "Opportunity",
    Quote = "Quote",
    Invoice = "Invoice",
    Item = "Item",
    Lead = "Lead",

    Other = "Other",
    Report = "Report",
}

export const INDEXDB_STORE_WIDGET = 'widget';

export enum WidgetID {
    JobsByPriority = 'jobs-by-priority',
    JobsByJobType = 'jobs-by-job-type',
    JobsByStatus = 'jobs-by-status',
    JobsOverdue = 'job-overdue',
    JobsDueIn7Days = 'job-duein7days',
    JobsUnassigned = 'job-unassigned',
    JobsNotDispatched = 'job-notdispatched',
    JobsInvoicedCount = 'job-invoiced-count',
    JobGrossMargin = 'job-gross-margin',
    JobsCustom = 'jobs-custom',
    LeadCustom = 'lead-custom',


    StagesByResources = 'stage-by-resources',
    StagesCount = 'stage-count',
    StagesCustom = 'stages-custom',
    StagesByResourcesAndStatuses = 'jobs-resources-statuses',


    OpportunityByStage = 'opportunity-by-stages',
    OpportunityByOwner = 'opportunity-by-owner',
    OpportunityByZone = 'opportunity-by-zone',
    OpportunityConversionRate = 'opportunity-conversion-rates',
    OpportunityByMonth = 'opportunity-by-month',
    OpportunityCustom = 'opportunity-custom',

    Report = 'report',

    Html = 'html',

}